import { render } from "./PromotionalSMS.vue?vue&type=template&id=079af71b&scoped=true&ts=true"
import script from "./PromotionalSMS.vue?vue&type=script&lang=ts"
export * from "./PromotionalSMS.vue?vue&type=script&lang=ts"

import "./PromotionalSMS.vue?vue&type=style&index=0&id=079af71b&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079af71b"]])

export default __exports__